module.exports = require("@nestjs/platform-fastify");